module.exports = __webpack_public_path__ + "static/img/Group357.3b78c80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Group357.png
// module id = KeH8
// module chunks = 13